/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  GamoraBase64URLGuard,
  GamoraErrorUnhandledException,
  assert,
} from '@ver.id/libs.internal.gamora';
import { HoruzProtocolChulakDataType } from '../../data.js';
import { HoruzProtocolChulakMessageGuard } from './base.js';

/**
 * Input type
 * @public
 */
export interface HoruzProtocolChulakMessageAppPresentationEnterGuardInput {}

/**
 * @public
 */
export class HoruzProtocolChulakMessageAppPresentationEnterGuard extends HoruzProtocolChulakMessageGuard<
  HoruzProtocolChulakDataType.STATE_APP_PRESENTATION_ENTER,
  HoruzProtocolChulakMessageAppPresentationEnterGuardInput
> {
  /**
   * Constructor
   * @param input - the input
   */
  constructor(input: HoruzProtocolChulakMessageAppPresentationEnterGuardInput) {
    super();
  }

  /**
   * Gets type
   */
  get type(): HoruzProtocolChulakDataType.STATE_APP_PRESENTATION_ENTER {
    return HoruzProtocolChulakDataType.STATE_APP_PRESENTATION_ENTER;
  }

  /**
   * Gets from JSON
   * @param input - Input string
   */
  static override fromJSON(
    input: unknown,
  ): HoruzProtocolChulakMessageAppPresentationEnterGuard {
    assert(
      typeof input === 'object' && input !== null,
      'Invalid input argument: not an object.',
    );
    return new HoruzProtocolChulakMessageAppPresentationEnterGuard(
      input as HoruzProtocolChulakMessageAppPresentationEnterGuardInput,
    );
  }

  /**
   * Get from base64URL
   * @param input - The input
   */
  static override fromBase64URL(
    input: unknown,
  ): HoruzProtocolChulakMessageAppPresentationEnterGuard {
    assert(
      typeof input === 'string' && input.length > 0,
      'Invalid input argument: not a valid string.',
    );

    // Parse input
    let json;
    try {
      json = JSON.parse(GamoraBase64URLGuard.fromBase64URL(input).toUTF8());
    } catch (e) {
      throw new GamoraErrorUnhandledException(
        'Unable to parse input: not valid JSON in base64url input.',
      );
    }

    // Create new guard
    return new HoruzProtocolChulakMessageAppPresentationEnterGuard(
      json as HoruzProtocolChulakMessageAppPresentationEnterGuardInput,
    );
  }

  /**
   * Gets JSON
   * @returns string
   */
  override toJSON() {
    return {};
  }

  /**
   * To Base64URL
   */
  override toBase64URL(): string {
    const json = this.toJSON();
    return GamoraBase64URLGuard.fromUTF8(JSON.stringify(json)).toBase64URL();
  }

  /**
   * Create clone
   */
  clone() {
    return HoruzProtocolChulakMessageAppPresentationEnterGuard.fromJSON(
      this.toJSON(),
    );
  }
}
